import { forwardRef, useEffect, useState } from "react";
import {
    LinkDismissRegular
} from "@fluentui/react-icons";
import { Button, ForwardRefComponent, MenuItem, makeStyles } from "@fluentui/react-components";
import { IRemoveSharingLinksActionButtonProps } from "./remove-sharing-links-action-button.props";
import { IRemoveSharingLinksSelection } from "@interfaces/actions/sharing-link-actions.interfaces";
import { IActionDefinition } from "@interfaces/actions/actions-common.interfaces";
import { getActionFormComponent, getActionResultComponent } from "lib/actions";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { PPAPermissions } from "lib/permissions";
import { usePPA } from "context/ppa-context";

const layoutStyles = makeStyles({
    mainWrapper: {
    },
    hidden: {
        display: 'none'
    }
});

export const RemoveSharingLinksActionButton: ForwardRefComponent<IRemoveSharingLinksActionButtonProps> = forwardRef((props, ref) => {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();
    const { hasPermission } = usePPA();

    const [model, setModel] = useState<IRemoveSharingLinksSelection | undefined>();
    const [className, setClassName] = useState<string>(styles.hidden);

    const onClick = () => {
        console.log(`RemoveSharingLinksActionButton -> onClick ->`);

        const actionDefinition: IActionDefinition<IRemoveSharingLinksSelection> = {
            actionType: 3,
            model: model,
            form: getActionFormComponent(3),
            result: getActionResultComponent(3)
        };

        if (props.onClick) {
            props.onClick(actionDefinition);
        }
    }

    useEffect(() => {
        console.log(`RemoveSharingLinksActionButton -> useEffect -> selectedItems ->`, props.selectedItems);

        if (props.selectedItems && props.selectedItems.length === 1) {
            const item = props.selectedItems[0];
            setModel({
                workspace: (item as any).workspaceUrl ? {
                    url: (item as any).workspaceUrl,
                    name: (item as any).workspaceName,
                    workspaceType: (item as any).workspaceType
                } : undefined,
                sharingItem: {
                    itemUniqueId: item.itemUniqueId,
                    itemName: item.itemName,
                    itemUrl: item.itemUrl,
                    itemType: item.itemType || 1 // Default to File if not specified
                },
                sharingLink: {
                    shareId: item.shareId,
                    linkUrl: item.linkUrl,
                    itemName: item.itemName,
                    itemUrl: item.itemUrl,
                    itemUniqueId: item.itemUniqueId,
                    permissionType: item.permissionType
                }
            });
        }
        else {
            // Clear the model
            setModel(undefined);
        }

        if (props.selectedItems && props.selectedItems.length > 0) {
            setClassName('');
        }
        else {
            setClassName(styles.hidden);
        }
    }, [props.selectedItems]);

    if (!hasPermission(PPAPermissions.RequestRemoveSharingLinksAction))
        return (<></>);

    if (props.isOverflowingMenu)
        if (props.selectedItems && props.selectedItems.length > 0)
            return (
                <MenuItem
                    icon={<LinkDismissRegular />}
                    disabled={props.selectedItems && props.selectedItems.length > 1}
                    onClick={onClick}>{t('remove')}</MenuItem>
            );
        else
            return <></>;

    return (
        <Button
            ref={ref}
            className={className}
            icon={<LinkDismissRegular />}
            disabled={props.selectedItems && props.selectedItems.length > 1}
            appearance="subtle"
            onClick={onClick}>{t('remove')}</Button>
    );
});